import {
  CommunicationDto,
  CommunicationType
} from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { User } from "@stores/core/models/User.ts";

/**
 *
 * @param workPhone the new work phone or falsy if the work phone must be removed
 * @param user the user whoose communications will be used to merge the work phone.
 *
 * It doesn't mutate the user communications but returns a new array.
 */
export function mergeWithCommunications(
  workPhone: string | undefined,
  user: User
) {
  let communications: CommunicationDto[] = [];
  if (workPhone && (!user || user.workPhone !== workPhone)) {
    communications = (
      user
        ? user.communications.filter(
            x => x.type !== CommunicationType.WorkPhone
          )
        : []
    ).concat([
      {
        type: CommunicationType.WorkPhone,
        value: workPhone,
        preferred: false
      }
    ]);
  } else if (!workPhone && user && user.workPhone) {
    communications = user.communications.filter(
      x => x.type !== CommunicationType.WorkPhone
    );
  } else if (workPhone && user && user.workPhone === workPhone) {
    communications = user.communications.filter(
      x => x.type === CommunicationType.WorkPhone
    );
  }
  return communications;
}
